import React from 'react';
import { ContainerTexto, TitleContainer, Text, FixedAnchor, } from '../styles';
import { VideoPlayer } from 'components/_REFACTORED/VideoPlayer';

import video from "../../../assets/video/entrega.mp4"
import { Anchor } from 'antd';

const Entrega: React.FC = () => {

  const { Link } = Anchor
  return (
    <>
      <ContainerTexto>
        <TitleContainer id="entrega-inicio">Entregas no CD</TitleContainer>
        <VideoPlayer videoFile={video} />
        <Text>
          Aqui o usuário poderá realizar o agendamento de uma entrega no centro de distribuição.
        </Text>
      </ContainerTexto>
      <FixedAnchor>
        <Link title="Início" href='#entrega-inicio' />
      </FixedAnchor>
    </>
  );
};

export default Entrega;
